
/*
 * flickSlide　jQueryプラグイン
 *
 * author: aquy.k ( hiroshi kawada )
 * create date: 2013-06-10
 * ver 0.7.0
 *
 *
 *
 * 更新履歴
 *
 * 2013.04.12　0.5.0　ある程度の機能を備えた安定版
 * 2013.06.10　0.6.0　ページャースライド機能に加え、各種（考えられる全ケースの対策）調整と、機能拡張、強化版
 * 2015.04.20　0.7.0　pagerContainer.length が未設定の場合のエラー解消
 *
 * 必要jsライブラリ＆設置コード例（最小）
<head>
…
<link rel="stylesheet" href="../../lib/css/jquery.flickslide.css">
<script src="http://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js"></script>
<script src="../../lib/js/jquery.exresize.0.1.0.js"></script>
<script src="../../lib/js/jquery.timers.js"></script>
<script src="../../lib/js/jquery.easing.1.3.js"></script>
<script src="../../lib/js/jquery.flickslide.0.6.0.js"></script>
<script>

	$(function(){

		$("#flick-slide").flickSlide();
	});
</script>
…
</head>

<body>
…
<section id="flick-slide">

<div>
<ol>
    <li><img src="../../lib/images/1.jpg" alt=""></li>
    <li><img src="../../lib/images/2.jpg" alt=""></li>
    <li><img src="../../lib/images/3.jpg" alt=""></li>
</ol>
</div>

</section>
…
</body>
 *
 *
 *
 * 高速化メモ
 *
 * ifとfunction{if}ではfunctionを通る段階で４倍時間がかかりif処理に時間がかかる
 * jQuery自体重いので軽量化するには極力jQuery関数やfunctionは使わない方がよい
 * 例：jQueryのIDセレクタ$('#id')よりネイティブgetElementByIdId('id')の方が爆速　等
 * $(".name")クラスだけを指定するのは禁止 $("div.name")の方がループ回数が大幅に削減される
 *
 * javascriptネイティブとjQueryでCSSの要素チェックのベンチーマークAdd Star
 * http://d.hatena.ne.jp/maruloop/20120109/1326091716
 *
 * Chromeにて変数+ネイティブだとフルjQueryに比べて20倍早い
 * 変数+ネイティブ（108）< ダイレクト+ネイティブ（180）< 変数+jQueryAPI（1484）< jQueryセレクタAPIダイレクト+jQueryAPI（2188）
 *
 * HTML5 × CSS3 × jQueryを真面目に勉強 ? #7 jQueryのセレクタAPIについて詳しく
 * http://dev.classmethod.jp/etc/html5-x-css3-x-jquery-7-jquery-selector/
 *
 *
 *
 * ※Android不具合情報
 *
 * ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
 * http://www.gravitypianist.info/android-40touchend
 *
 * Androidの標準ブラウザにおけるリンク要素のアウトラインの不具合について
 * http://blog.bluearrowslab.com/smartphone/topicks/534/
 *
 * ※au URBANOがCSSのopacityを動的にアルファ変更すると激重で0.5秒固まる
 * ※Androidは基本的に動的処理に弱い
 *
 *
 *
 * ※バグ情報
 * IE8のみopacityで親要素を透明にしても子要素は透明にならないので直接指定するしかない
 *
 *
 *
 * ※その他注意事項
 * IE7のみコンフィグ設定時のプロパティーで最後の列に,区切り（例～～ opacity : true, ;）を入れると処理が停止するので注意
 *
 */

//※※Line427 本番前に変更する必要あり。

(function($){

	// プラグイン名（flickSlide）を指定　関数にコンフィグオブジェクトを渡す
	$.fn.flickSlide = function( config ){

		// 要素を退避
		var elements = this;

		/*
		 * 引数の初期値を設定（カンマ区切り）
		 -----------------------------------------------------*/
		 var defaults = {

			// エレメント参照：メイン
			mainElement : elements.children("div").first(),			// 親要素内直下の最初のdiv要素を選択

			// エレメント参照：メインネイバーズボタン
			mainNeighborsElement : elements.children("ul").first(),	// 親要素内直下の最初のul要素を選択

			// エレメント参照：ページャー
			pagerElement : null,

			// エレメント参照：ページャーネイバーズボタン
			pagerNeighborsElement : null,

			// メインネイバーズボタンの自動生成
			createMainNeighbors : false,

			// メインネイバーズボタンの垂直位置を中央に
			mainNeighborsVerticalCenter : true,

			// ページャーの自動生成　null = なし　"pointer" = CSSポインター　"thumbnail" = メインエレメントのサムネイルを自動コピー
			createPager : null,

			// ページャーのスライド機能
			pagerSlide : false,

			// ページャーネイバーズボタンの自動生成
			createPagerNeighbors : false,

			// ページャーネイバーズボタンの垂直位置を中央に
			pagerNeighborsVerticalCenter : true,

			// メインエレメントの子liの横幅設定　数値1以上 = px　デフォルト = 0:100%（※outerも含む）
			mainListWidth : 0,

			// ページャーエレメントの子liの横幅設定　数値1以上 = px　デフォルト = 0:auto（※outerも含む）
			pagerListWidth : 0,

			// フリック操作性設定
			//-----------------------------------------------------
			// タッチムーブ時の移動量補正　デフォルト = 0.5:半減（アップルストア仕様）　1:ダイレクト　2:2倍
			movementCorrection : 0.5,

			// タッチムーブ時に垂直に一定以上動かした場合の感知範囲　px
			verticalSensingRange : 0,

			// touchend時でスライド送りをするかの左右のゆとり（liの幅で計算）　デフォルト = 0.1:左右5% 単位（軽い）　0:遊びなし（固い）　1:左右50%（重い）
			spaceRange : 0.1,
			//-----------------------------------------------------

			// 繰り返し
			repeat : false,

			// 自動スライド間隔の秒数　0:停止
			timer : 0,

			// hover時にタイマーを停止する
			hoverStopTimer : true,

			// スライドが完了するまでのスピード　デフォルト400:アップルストアぐらい
			slideSpeed : 400,

			/* CSS3 transitionを使用した加速/減速
			 * "ease"			= 開始と終了を滑らかに（初期値） = cubic-bezier(0.25, 0.1, 0.25, 1.0)
			 * "linear"			= 一定 = cubic-bezier(0.0, 0.0, 1.0, 1.0)
			 * "ease-in"		= ゆっくり開始 = cubic-bezier(0.42, 0, 1.0, 1.0)
			 * "ease-out"		= ゆっくり終了 = cubic-bezier(0, 0, 0.58, 1.0)
			 * "ease-in-out"	= ゆっくり開始、ゆっくり終了 = cubic-bezier(0.42, 0, 0.58, 1.0)
			 * "カスタム設定"	= 3次ベジェ曲線のP1とP2を (x1, y1, x2, y2) で指定
			 */
			 transitionEasing : "ease",

			// jquery.easing.1.3.jsを使用した加速/減速 動作参考：http://semooh.jp/jquery/cont/doc/easing/
			jqueryEasing : "easeOutExpo",

			// ネイバーズボタンの非アクティブ時に埋め込まれるクラス名
			disabledClassName : "disabled",

			// ページャーアクティブ時に埋め込まれるクラス名
			selectedClassName : "active",

			// ページャーの透明度処理によるロールオーバー表現設定　0 ～ 1まで　デフォルト = 0.5:半透明　1:オフ （※Androidはアルファ処理が激重（約0.5秒フリーズ）iOSも若干重い（約0.1秒）ので、SPは強制的に1）
			opacity : 0.5,

			// 透明度の変化が終わるまでのスピード
			opacityAnimateSpeed : 300,

			// デバッグを行うかどうか　// ※IE8以下はobjectプロパティがundefinedの場合中断されるので注意　IE8以下ではデバッグしない方が良い
			debug : false,

			modal : false // ※モーダル表示拡張
		};

		// 渡されたコンフィグとデフォルトをマージする
		var settings = $.extend( {}, defaults, config );



		//-----------------------------------------------------



		// 最小設置時の自動生成の場合のデフォルトクラス名
		var defaultClassNameMain			= "jquery_flick-slide_main";
		var defaultClassNameMainNeighbors	= "jquery_flick-slide_main-neighbors";

		var defaultClassNamePagerPointer	= "jquery_flick-slide_pointer";
		var defaultClassNamePager			= "jquery_flick-slide_pager";
		var defaultClassNamePagerSlide		= "jquery_flick-slide_pager-slidemode";
		var defaultClassNamePagerNeighbors	= "jquery_flick-slide_pager-neighbors";

		var defaultClassNameNeighborsPrev	= "prev";
		var defaultClassNameNeighborsNext	= "next";



		/*
		 * 基礎格納
		 -----------------------------------------------------*/
		 var mainElement				= $( settings.mainElement );
		 var mainNeighborsElement	= $( settings.mainNeighborsElement );
		 var pagerElement			= $( settings.pagerElement );
		 var pagerNeighborsElement	= $( settings.pagerNeighborsElement );

		var mainContainer			= mainElement.children('ol');	// フローコンテンツ的にolが相応しいのでとりあえず強制
		var mainListContainer		= mainContainer.children('li');
		var listCount				= mainListContainer.length;	// リスト数

		// メインエレメントにid、classの属性がなければデフォルトクラス名を当てる
		if ( typeof mainElement.attr('id') === "undefined" && typeof mainElement.attr('class') === "undefined" ) {

			mainElement.addClass( defaultClassNameMain );
		}


		// 外部横幅css対策　cssでデザイン的に設定される場合があるので取得処理　outerWidth({ margin: true });でも可だがこっちで軽量化
		// main li　※全て均等に掛っている事が条件　個別で違う場合は崩壊する
		var mainListFirst		= mainListContainer.first();
		var mainMarginWidth		= parseInt( mainListFirst.css('margin-left') ) + parseInt( mainListFirst.css('margin-right') );				// margin幅計算
		var mainPaddingWidth	= parseInt( mainListFirst.css('padding-left') ) + parseInt( mainListFirst.css('padding-right') );				// padding幅計算
		var mainBorderWidth		= parseInt( mainListFirst.css('border-left-width') ) + parseInt( mainListFirst.css('border-right-width') );	// border幅計算
		var mainOuterWidth		= mainMarginWidth + mainPaddingWidth + mainBorderWidth;	// 外部横幅


		// タッチ操作可能かどうか
		var touchable = typeof ontouchstart !== 'undefined';



		/*
		 * CSS3 アニメーション　で使用するベンダープレフィックスを摘出
		 -----------------------------------------------------*/
		var vendorPrefix = [	// ※注意　transitionを先頭に置くと何故か非対応のChromeが拾って動かなくなるので一番下に

		[ '-webkit-transition', '-webkit-transition', '-webkit-transform', 'webkitTransitionEnd' ],
		[ 'MozTransition',      '-moz-transition',    '-moz-transform',    'transitionend' ],
		[ 'OTransition',        '-o-transition',      '-o-transform',      'oTransitionEnd' ],
		[ '-ms-transition',     '-ms-transition',     '-ms-transform',     'msTransitionEnd' ],
		[ 'transition',         'transition',         'transform',         'transitionEnd' ]
		];

		var div = document.createElement('div');	// undefinedかどうか調べる
		var css3Animation = {};

		for ( var i = 0, len = vendorPrefix.length; i < len; i++ ) {

			if ( div.style[ vendorPrefix[i][0] ] !== void 0 ) {	// undefinedではなく該当するプロパティーがあれば

				css3Animation.transition    = vendorPrefix[i][1];
				css3Animation.transform     = vendorPrefix[i][2];
				css3Animation.transitionend = vendorPrefix[i][3];

				break;
			}
		}

		// フラグ用
		var css3AnimationSupport = css3Animation.transition && css3Animation.transform;



		/*
		 * 動的変数をローカル宣言
		 -----------------------------------------------------*/
		var main = {			// メインエレメント用変数オブジェクト

			name : "main",		// 識別時に使用する名前
			element : mainContainer,
			listWidth : 0,		// メインエレメント内子liの横幅
			leftIndent : 0,		// メインエレメントの子liの横幅が指定された場合のセンタリング用インデント値
			moveSpeed : 0,		// touchmoveの移動速度の監視に必要
			connectCount : 0,
			transform : false	// アニメーションの多重処理防止用フラグ　リサイズ時に無駄なcss.transitionを抑制
		};

		var mainRightEndLimit;	// スライド時の右端のリミット
		var mainClearSpace;		// フリック時の左右のゆとり

		var defaultHeight = $('body').height();	// 動的に高さが変更されるか監視する為の値　変化前を記憶しておく

		var yFlag = false;	// スクロール感知
		var xFlag = false;	// スライド感知

		var runningTimer = false;	// タイマーの多重処理防止用フラグ
		var time = 0;



		/*
		 * ユーザーエージェント
		 -----------------------------------------------------*/
		var strUserAgent = navigator.userAgent.toLowerCase();	// 文字列を小文字で出力
		var smartPhoneUserAgent	= [ 'iphone', 'ipad', 'ipod', 'android' ];

		var terminal = "pc";	// PC版は画像ドラッグでthis.touchedがtrueのままになるのでフォーカスを奪われないようにするためのフラグ

		for ( var i = 0; i < smartPhoneUserAgent.length; i++ ) {

			// スマートフォンの場合
			if ( strUserAgent.indexOf( smartPhoneUserAgent[i], 0 ) != -1 ) {

				terminal = "sp";
				settings.opacity = 1;	// スマートフォンの場合はレンダリング速度が低下するので強制的に透明処理を行わない（※特にAndroid）

				break;
			}
			/*
			// Androidの場合
			if ( strUserAgent.indexOf( 'android', 0 ) != -1 ) {

				settings.opacity = 1;	// ※Androidはアルファ処理が激重なので強制的に透明にしない
			}
			*/
		}





		/*
		 * 各種エレメント処理　自動生成関連
		 -----------------------------------------------------*/



		/*
		 * メインエレメント用　ネイバーズボタン（自動生成）
		 -----------------------------------------------------*/
		// 自動生成フラグ　＆　エレメントがない場合に要素を自動生成（多重設置回避）
		if ( settings.createMainNeighbors && !mainNeighborsElement.length ) {

			mainElement.before(	// .before IE7非対応
				'<ul class="'+ defaultClassNameMainNeighbors +'">'+
				'<li class="'+ defaultClassNameNeighborsPrev +'"></li>'+
				'<li class="'+ defaultClassNameNeighborsNext +'"></li>'+
				'</ul>'
				);

			mainNeighborsElement = elements.children( "ul."+ defaultClassNameMainNeighbors );
		}

		// prev、nextボタンが存在する場合
		if ( mainNeighborsElement.length ) {

			var setMainNeighbors = true;	// 処理を許可

			var mainPrevElement = mainNeighborsElement.children('li.'+ defaultClassNameNeighborsPrev );
			var mainNextElement = mainNeighborsElement.children('li.'+ defaultClassNameNeighborsNext );
		}

		if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();



		/*
		 * ページャー
		 -----------------------------------------------------*/
		 var pagerContainer = pagerElement.children('ol');

		// "pointer"自動生成フラグ
		if ( settings.createPager == "pointer" && !pagerContainer.length ) {

			if ( !pagerElement.length ) {	// ページャーエレメントそのものがない場合

				elements.append('<div class="'+ defaultClassNamePagerPointer +'"><ol></ol></div>');
				pagerElement = elements.children( "div."+ defaultClassNamePagerPointer );

			} else {						// ページャーエレメントはあるもののol要素がない場合

				pagerElement.append('<ol></ol>');
			}

			pagerContainer = pagerElement.children('ol');

			for ( var i = 0; i < listCount; i++ ) {

				var addListTag = $('<li><span></span></li>');
				pagerContainer.append( addListTag );
			}

		// "thumbnail"自動生成フラグ
	} else if ( settings.createPager == "thumbnail" && !pagerContainer.length ) {

			if ( !pagerElement.length ) {	// ページャーエレメントそのものがない場合

				elements.append('<div class="'+ defaultClassNamePager +'"><ol></ol></div>');
				pagerElement = elements.children( "div."+ defaultClassNamePager );

			} else {						// ページャーエレメントはあるもののol要素がない場合

				pagerElement.append('<ol></ol>');
			}

			pagerContainer = pagerElement.children('ol');

			for ( var i = 0; i < listCount; i++ ) {

				var image = mainListContainer.eq(i).find("img").first().attr('src');

				// var addListTag = $('<li><span><img src="../../lib/'+ image +'"></span></li>');
				var addListTag = $('<li><span><img src="'+ image +'"></span></li>');
				pagerContainer.append( addListTag );
			}
		}

		// ページャーが存在する場合
		if ( pagerContainer.length ) {

			var setPager = true;	// 処理を許可

			var pagerListContainer	= pagerContainer.children('li');

			// pager li　※全て均等に掛っている事が条件　個別で違う場合は崩壊する
			var pagerListFirst		= pagerListContainer.first();
			var pagerMarginWidth	= parseInt( pagerListFirst.css('margin-left') ) + parseInt( pagerListFirst.css('margin-right') );				// margin幅計算
			var pagerPaddingWidth	= parseInt( pagerListFirst.css('padding-left') ) + parseInt( pagerListFirst.css('padding-right') );			// padding幅計算
			var pagerBorderWidth	= parseInt( pagerListFirst.css('border-left-width') ) + parseInt( pagerListFirst.css('border-right-width') );	// border幅計算
			var pagerOuterWidth		= pagerMarginWidth + pagerPaddingWidth + pagerBorderWidth;	// 外部横幅

			if ( settings.pagerSlide ) pagerElement.addClass( defaultClassNamePagerSlide );
			pagerListContainer.first().addClass( settings.selectedClassName );

			// CSS　opacityロールオーバー表現　opacityが1より低い場合は処理する
			if( settings.opacity < 1 ){

				// ※バグ　IE8はopacityで親要素を透明にしても子要素は透明にならないので直接指定するしかない
				var pagerContainerOpacityTarget = pagerListContainer;

				if ( strUserAgent.indexOf( 'msie 8', 0 ) != -1 && pagerListContainer.find('img').length ) {	// IE8で尚且つ子要素にimgがある場合

					pagerContainerOpacityTarget = pagerListContainer.find('img');
				}

				pagerContainerOpacityTarget.css({ opacity : settings.opacity });

				pagerContainerOpacityTarget.hover(

					function(){	// over

						$(this).stop().animate( { opacity: 1 }, settings.opacityAnimateSpeed );
					},
					function(){	// out

						$(this).stop().animate( { opacity: settings.opacity }, settings.opacityAnimateSpeed );
					}
					);
			}

		// 存在しないにも関わらずスライドフラグが立っている場合はオフにする
	} else if ( settings.pagerSlide ) {

		settings.pagerSlide = false;
	}

		// ページャー関連の動的変数　スライドさせる場合のローカル宣言
		if ( settings.pagerSlide ) {

			var pager = {			// ページャーエレメント用変数オブジェクト

				name : "pager",		// 識別時に使用する名前
				element : pagerContainer,
				listWidth : 0,		// ページャーエレメント内子liの横幅
				leftIndent : 0,		// ページャーエレメントの子liの横幅が指定された場合のセンタリング用インデント値
				moveSpeed : 0,		// touchmoveの移動速度の監視に必要
				connectCount : 0,
				transform : false	// アニメーション感知　リサイズ時に無駄なcss.transitionを抑制
			};

			var pagerRightEndLimit;
			var pagerClearSpace;
		}



		/*
		 * ページャーエレメント用　ネイバーズボタン（自動生成）
		 -----------------------------------------------------*/
		// ページャーが存在　＆　自動生成フラグ　＆　スライド機能が有効　＆　エレメントがない場合に要素を自動生成（多重設置回避）
		if ( setPager && settings.createPagerNeighbors && settings.pagerSlide && !pagerNeighborsElement.length ) {

			pagerElement.before(	// .before IE7非対応
				'<ul class="'+ defaultClassNamePagerNeighbors +'">'+
				'<li class="'+ defaultClassNameNeighborsPrev +'"></li>'+
				'<li class="'+ defaultClassNameNeighborsNext +'"></li>'+
				'</ul>'
				);

			pagerNeighborsElement = elements.children( "ul."+ defaultClassNamePagerNeighbors );
		}

		// prev、nextボタンが存在する場合
		if ( pagerNeighborsElement.length ) {

			var setPagerNeighbors = true;	// 処理を許可

			var pagerPrevElement = pagerNeighborsElement.children('li.'+ defaultClassNameNeighborsPrev );
			var pagerNextElement = pagerNeighborsElement.children('li.'+ defaultClassNameNeighborsNext );
		}

		if( setPagerNeighbors && !settings.repeat ) neighborsSetDisabled();



		/*
		 * モーダル表示用クローン（自動生成）
		 -----------------------------------------------------*/
		 if ( settings.modal ) {
		 	var x = elements.attr("id");
		 	x = x +"2";
		 	console.log(x);
		 	//mainElement.clone(true).appendTo("#flick-slide");
		 	elements.clone(true).insertAfter(this).removeAttr("id").attr("id",x);
		 }










		//-----------------------------------------------------





		/*
		 * 表示サイズ自動処理
		 -----------------------------------------------------*/
		 $(window).load( function() {

		 	autoSizing();

		 	if( settings.debug ) debug( {}, "ロード完了" );
		 });



		 $(window).resize( function(e){

		 	autoSizing();

			defaultHeight = $('body').height();		// $(window).resizeからはexResizeが実行されないようにdefaultHeightを更新

			if( settings.debug ) debug( {}, "リサイズ" );
		});



		// 自身以外から動的に高さが変更されスクロールバーが出現した場合の横幅再計算
		/*
		 * メモ
		 *
		 * $(window).resize()では動的な縦幅の変更は監視できないので、jquery.exresize.0.1.0.jsでbody要素がリサイズされるか監視
		 * この処理は重く多用できないので動的変更時（複数設置した場合の初回用）のみで使用すること
		 */
		 $('body').exResize( function(){

			if( defaultHeight != $('body').height() ) {	// 記憶した縦幅と現在の縦幅が違う場合

				autoSizing();

				if( settings.debug ) debug( {}, "動的リサイズ" );
			}
		});



		// 自動サイズ処理
		function autoSizing() {

			var mainElementWidth = parseInt( mainElement.css('width') );

			// メインエレメントの子liの横幅
			if ( !settings.mainListWidth )	{	// 0の場合はmainElementの幅（100%）

				main.listWidth = mainElementWidth;

			} else {						// 設定があれば

				main.listWidth = settings.mainListWidth;
				//main.leftIndent = ( mainElementWidth - main.listWidth ) / 2;


				main.leftIndent = 0;

				//console.log(main.leftIndent);

				//main.leftIndent = ( mainElementWidth - main.listWidth );
			}

			mainRightEndLimit = -main.listWidth * ( listCount - 1 );
			mainClearSpace = ( main.listWidth * settings.spaceRange ); // フリック時の左右のゆとり

			mainContainer.css({ width : main.listWidth * listCount });

			// 横座標　式
			var abscissa = main.leftIndent + -main.listWidth * main.connectCount;

			if ( css3AnimationSupport ) {	// css3Animationが使用できる場合

				var css = {};

				// アニメーション中じゃなければ無駄なトランジションを消してアニメーションさせない
				if ( !main.transform ) css[ css3Animation.transition ] = 'none';
				css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';

				mainContainer.css( css );

			} else {						// 古いブラウザ等、非対応の場合

				mainContainer.css({ left: abscissa });
			}

			mainListContainer.css({ width : main.listWidth - mainOuterWidth });
			mainElement.css({ height : mainContainer.height() }); // 縦幅の最大値



			// メインエレメントにネイバーズボタンが存在　＆　縦位置の中央フラグがtrueの場合は中央揃えに
			if ( setMainNeighbors && settings.mainNeighborsVerticalCenter ) {

				var mainPrevHeight = mainPrevElement.height() + parseInt( mainPrevElement.css('border-top-width') ) + parseInt( mainPrevElement.css('border-bottom-width') );
				var mainNextHeight = mainNextElement.height() + parseInt( mainNextElement.css('border-top-width') ) + parseInt( mainNextElement.css('border-bottom-width') );
				mainPrevElement.css({ 'margin-top' : mainElement.height() / 2 - mainPrevHeight / 2 });
				mainNextElement.css({ 'margin-top' : mainElement.height() / 2 - mainNextHeight / 2 });
			}

			// ページャーエレメントにネイバーズボタンが存在　＆　縦位置の中央フラグがtrueの場合は中央揃えに
			if ( setPagerNeighbors && settings.pagerNeighborsVerticalCenter ) {

				var pagerPrevHeight = pagerPrevElement.height() + parseInt( pagerPrevElement.css('border-top-width') ) + parseInt( pagerPrevElement.css('border-bottom-width') );
				var pagerNextHeight = pagerNextElement.height() + parseInt( pagerNextElement.css('border-top-width') ) + parseInt( pagerNextElement.css('border-bottom-width') );
				pagerPrevElement.css({ 'margin-top' : pagerElement.height() / 2 - pagerPrevHeight / 2 });
				pagerNextElement.css({ 'margin-top' : pagerElement.height() / 2 - pagerNextHeight / 2 });
			}



			// ページャーのスライド機能を使用する場合
			if ( settings.pagerSlide ) {

				var pagerElementWidth = parseInt( pagerElement.css('width') );

				// メインエレメントの子liの横幅
				if ( !settings.pagerListWidth )	{	// 0の場合はmainElementの幅（100%）

					pager.listWidth = pagerElementWidth;

				} else {							// 設定があれば
					pager.listWidth = settings.pagerListWidth;
					//pager.leftIndent = ( pagerElementWidth - pager.listWidth ) / 2;
					pager.leftIndent = 0;
				}

				pagerRightEndLimit = -pager.listWidth * ( listCount - 1 );
				pagerClearSpace = ( pager.listWidth * settings.spaceRange ); // フリック時の左右のゆとり

				pagerContainer.css({ width : pager.listWidth * listCount });

				// 横座標　式
				var abscissaPager = pager.leftIndent + -pager.listWidth * pager.connectCount;

				if ( css3AnimationSupport ) {	// css3Animationが使用できる場合

					var css = {};

					// アニメーション中じゃなければ無駄なトランジションを消してアニメーションさせない
					if ( !main.transform ) css[ css3Animation.transition ] = 'none';
					css[ css3Animation.transform ] = 'translate3d( '+ abscissaPager +'px, 0, 0 )';

					pagerContainer.css( css );

				} else {						// 古いブラウザ等、非対応の場合

					pagerContainer.css({ left : abscissaPager });
				}

				pagerListContainer.css({ width : pager.listWidth - pagerOuterWidth });
				pagerElement.css({ height : pagerContainer.height() }); // 縦幅の最大値
			}
		}



		// アニメーションの多重処理防止フラグ関連　css3Animation使用可能な場合でtransitionend時
		if ( css3Animation.transitionend ) {

			// リサイズ時のアニメーションを抑制
			mainContainer.bind( css3Animation.transitionend, function(){

				main.transform = false;			// アニメーションが完了したらフラグを消す
			});

			// ページャーのスライド機能を使用する場合
			if ( settings.pagerSlide ) {

				// リサイズ時のアニメーションを抑制
				pagerContainer.bind( css3Animation.transitionend, function(){

					pager.transform = false;	// アニメーションが完了したらフラグを消す
				});
			}
		}





		/*
		 * フリック、マウススライド処理
		 -----------------------------------------------------*/
		 var events = {

		 	touchstart : function(e){

		 		this.touched = true;

				// ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
				// http://www.gravitypianist.info/android-40touchend
				yFlag = false;

				var touches = touchable ? e.originalEvent.touches[0] : e;

				this.pageX = touches.clientX;	// 開始座標
				this.xBegin = -e.data.listWidth * e.data.connectCount;
				this.x = this.xBegin;

				this.pageY = touches.clientY;	// 開始座標

				this.startX = this.pageX;
				this.startY = this.pageY;

				// タイマー設定の場合のストップ処理
				if( settings.timer ) {

					runningTimer = false;
					time = 0;
					elements.stopTime();
				}

				if( e.data.name == "pager" && settings.pagerSlide ) pagerListContainer.bind( 'click', pagerRelease );

				if( settings.debug ) debug( this, "タッチ" );

				// PC版は画像ドラッグでthis.touchedがtrueのままになるのでフォーカスを奪われないようにする
				if( terminal == "pc" ) return false;
			},

			touchmove : function(e){

				if( !this.touched ){	// 過剰動作の防止
					return;
				}

				// animateの場合、前回の処理が終わる前に操作すると多重処理になるので停止させる
				if ( !css3AnimationSupport ) $(this).stop();

				var touches = touchable ? e.originalEvent.touches[0] : e;

				this.x = this.x - ( this.pageX - touches.clientX );

				if( e.data.name == "pager" && settings.pagerSlide ) e.data.moveSpeed = ( touches.clientX - this.pageX ) * 10;	// touchmoveの移動速度を割り出す

				this.pageX = touches.clientX;
				this.pageY = touches.clientY;

				// 移動距離計算
				this.distanceX = this.pageX - this.startX;
				this.distanceY = this.pageY - this.startY;

				// フリック、スワイプ感知フラグ
				if ( !xFlag && Math.abs( this.distanceY ) - Math.abs( this.distanceX ) > settings.verticalSensingRange ) {	// 垂直判定

					yFlag = true;
				}

				if ( !yFlag && Math.abs( this.distanceX ) - Math.abs( this.distanceY ) > 0 ) {			// 水平判定

					xFlag = true;

					e.preventDefault();	// スクロールを停止して以下を実行

					// 横座標
					var abscissa;
													// メインは移動量補正　式
													if ( e.data.name == "main" )		abscissa = e.data.leftIndent + this.x * settings.movementCorrection - e.data.listWidth * ( 1 - settings.movementCorrection ) * e.data.connectCount;
					else if ( settings.pagerSlide )	abscissa = e.data.leftIndent + this.x;	// 無段階スライドの場合は補正しない

					if ( css3AnimationSupport ) {	// css3Animationが使用できる場合

						var css = {};

						css[ css3Animation.transition ] = 'none';
						css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';

						$(this).css( css );

					} else {						// 古いブラウザ等、非対応の場合

						$(this).css({ left: abscissa });
					}
				}

				if( settings.debug ) debug( this, "move" );
			},

			// ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
			// http://www.gravitypianist.info/android-40touchend

			// mouseoutは子要素にも反応してしまう
			// mouseenter/mouseleaveであれば子要素のイベントは発生しないがmouseleaveはIE6,7,8は対応していない
			//'touchend mouseup mouseout': function(e){
				touchend : function(e){

				if ( !this.touched ) {	// 過剰動作の防止
					return;
				}

				e.data( this );
			}
		};


		// イベント登録
		if ( touchable ) {

			mainContainer
			.bind( 'touchstart', main,             events.touchstart )
			.bind( 'touchmove',  main,             events.touchmove )
			.bind( 'touchend',   mainSlideRelease, events.touchend );

		} else {

			mainContainer
			.bind( 'mousedown',  main,             events.touchstart )
			.bind( 'mousemove',  main,             events.touchmove )
			.bind( 'mouseup',    mainSlideRelease, events.touchend );
		}

		// mouseout代用対策 // 将来的にreleaseOutside処理を作った方が良いがとりあえず
		mainContainer.hover(

			function(){	// over

				// hover時にタイマーを止める場合（SPはtouchstart時に停止させるので不要　※SPも実行するとタイマーが永遠に停止するためPCのみにする）
				if ( terminal == "pc" && settings.hoverStopTimer ) {

					runningTimer = false;
					elements.stopTime();

					if( settings.debug ) debug( {}, "タイマーストップ" );
				}
			},

			function(){	// out

				if( settings.timer ) autoSlideTimer();

				if ( this.touched ) {

					mainSlideRelease( this );
				}
			}
			);



		// release処理　'touchend mouseup'とhover()が同一処理なのでファンクション化
		function mainSlideRelease( target ){

			target.touched = false;

			if ( xFlag ) {

				var pagerListContainerActive = pagerContainer.children( "li." + settings.selectedClassName );

				// 右
				if ( target.xBegin > target.x && !( target.xBegin === mainRightEndLimit ) ) {

					// ゆとり　mainClearSpace未満で放した場合は元に戻す
					if( target.xBegin - mainClearSpace < target.x ) {

					} else {

						main.connectCount ++;

						if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();

						pagerListContainerActive.removeClass( settings.selectedClassName );
						pagerListContainerActive.next().addClass( settings.selectedClassName );

						if ( settings.pagerSlide ) {

							pager.connectCount = main.connectCount;
							animationMove( pager );
						}
					}

				// 左
			} else if ( target.xBegin < target.x && !( target.xBegin === 0 ) ) {

					// ゆとり　mainClearSpace未満で放した場合は元に戻す
					if( target.xBegin + mainClearSpace > target.x ) {

					} else {

						main.connectCount --;

						if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();

						pagerListContainerActive.removeClass( settings.selectedClassName );
						pagerListContainerActive.prev().addClass( settings.selectedClassName );

						if ( settings.pagerSlide ) {

							pager.connectCount = main.connectCount;
							animationMove( pager );
						}
					}
				}
			}

			if ( xFlag ) animationMove( main );

			yFlag = false;	// スクロール感知
			xFlag = false;	// スライド感知

			// タイマー　hoverストップ設定でなければRelease後にスタート
			if ( settings.hoverStopTimer && settings.timer ) autoSlideTimer();

			if( settings.debug ) debug( target, "release" );
		}



		//-----------------------------------------------------



		// ページャーが存在する場合
		if ( setPager ) {

			// mouseout代用対策 // 将来的にreleaseOutside処理を作った方が良いがとりあえず
			pagerContainer.hover(

				function(){	// over

					// hover時にタイマーを止める場合（SPはtouchstart時に停止させるので不要　※SPも実行するとタイマーが永遠に停止するためPCのみにする）
					if ( terminal == "pc" && settings.hoverStopTimer ) {

						runningTimer = false;
						elements.stopTime();

						if( settings.debug ) debug( {}, "タイマーストップ" );
					}
				},

				function(){	// out

					if( settings.timer ) autoSlideTimer();

					if ( this.touched ) {

						pagerSlideRelease( this );
					}
				}
				);
		}

		// ページャーのスライド機能を使用する場合
		if ( settings.pagerSlide ) {

			// イベント登録
			if ( touchable ) {

				pagerContainer
				.bind( 'touchstart', pager,             events.touchstart )
				.bind( 'touchmove',  pager,             events.touchmove )
				.bind( 'touchend',   pagerSlideRelease, events.touchend );

			} else {

				pagerContainer
				.bind( 'mousedown',  pager,             events.touchstart )
				.bind( 'mousemove',  pager,             events.touchmove )
				.bind( 'mouseup',    pagerSlideRelease, events.touchend );
			}


		}

		// release処理　'touchend mouseup'とhover()が同一処理なのでファンクション化
		function pagerSlideRelease( target ){

			target.touched = false;

			if ( xFlag ) {

				// 右
				if ( target.xBegin > target.x && !( target.xBegin === pagerRightEndLimit ) ) {

					// ゆとり　pagerClearSpace未満で放した場合は元に戻す
					if( target.xBegin - pagerClearSpace < target.x ) {

					} else {

						pager.flickX = target.xBegin - target.x - pager.moveSpeed;

						for ( var i = pager.listWidth / 2; i < pager.flickX; i += pager.listWidth ) {

							pager.connectCount ++;

							if ( pager.connectCount >= listCount - 1 ) break;
						}

						if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
					}

				// 左
			} else if ( target.xBegin < target.x && !( target.xBegin === 0 ) ) {

					// ゆとり　pagerClearSpace未満で放した場合は元に戻す
					if( target.xBegin + pagerClearSpace > target.x ) {

					} else {

						pager.flickX = target.xBegin - target.x - pager.moveSpeed;

						for ( var i = -pager.listWidth / 2; i > pager.flickX; i -= pager.listWidth ) {

							pager.connectCount --;

							if ( pager.connectCount <= 0 ) break;
						}

						if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
					}
				}
			}

			if ( xFlag ) {	// イベントハンドラを削除してアニメーション

				pagerListContainer.unbind( 'click' );
				animationMove( pager );
			}

			yFlag = false;	// スクロール感知
			xFlag = false;	// スライド感知

			// タイマー　hoverストップ設定でなければRelease後にスタート
			if ( !settings.hoverStopTimer && settings.timer ) autoSlideTimer();

			if( settings.debug ) debug( target, "release" );
		}



		/*
		 * ページャーボタン処理
		 -----------------------------------------------------*/
		 function pagerRelease(){

			// main
			main.connectCount = pagerListContainer.index(this);
			animationMove( main );

			if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();


			// pager
			if ( pagerContainer.length ) {
				pagerListContainer.removeClass( settings.selectedClassName );
				$(this).addClass( settings.selectedClassName );
			}

			// ページャーのスライド機能を使用する場合
			if ( settings.pagerSlide ) {

				pager.connectCount = main.connectCount;
				animationMove( pager );
			}


			// time
			time = 0;


			if( settings.debug ) debug( {}, "ページャー移動" );
		}

		// ページャーが存在し静止ページャーの場合
		if ( setPager && !settings.pagerSlide ) {

			pagerListContainer.bind( 'click', pagerRelease );
		}





		/*
		 * ネイバーズボタン関連
		 -----------------------------------------------------*/

		// メインエレメントにprev、nextボタンが存在する場合
		if ( setMainNeighbors ) {

			mainPrevElement.click( function(){ mainNeighborsSwitch( main, -1 ); } );
			mainNextElement.click( function(){ mainNeighborsSwitch( main, 1 ); });
		}

		// ページャーエレメントにprev、nextボタンが存在する場合
		if ( setPagerNeighbors ) {

			pagerPrevElement.click( function(){ mainNeighborsSwitch( main, -1 ); } );
			pagerNextElement.click( function(){ mainNeighborsSwitch( main, 1 ); } );
			//pagerPrevElement.click( function(){ pagerNeighborsSwitch( pager, -1 ); } );
			//pagerNextElement.click( function(){ pagerNeighborsSwitch( pager, 1 ); } );
		}



		// ネイバーズボタン処理
		function mainNeighborsSwitch( variableObject, value ){

			neighborsMove( variableObject, value );

			// ページャーのスライド機能を使用する場合
			if ( settings.pagerSlide ) {

				pager.connectCount = main.connectCount;
				animationMove( pager );
			}

			//if( settings.debug ) debug( {}, "メインネイバーズボタン移動" );
		}
		/*
		function pagerNeighborsSwitch( variableObject, value ){

			neighborsMove( variableObject, value );

			main.connectCount = pager.connectCount;
			animationMove( main );

			if( settings.debug ) debug( {}, "ページャーネイバーズボタン移動" );
		}
		*/


		// ネイバーズボタン　スライド処理
		function neighborsMove( variableObject, value ){

			variableObject.connectCount += value;
			time = 0;

			if( settings.repeat ) {	// 繰り返し設定の場合

				if( variableObject.connectCount < 0 ){

					variableObject.connectCount = listCount - 1;

				} else if ( variableObject.connectCount > listCount - 1 ){

					variableObject.connectCount = 0;
				}

			} else {	// 繰り返し設定がない場合はリミット

				if( variableObject.connectCount < 0 ){

					variableObject.connectCount = 0;

				} else if ( variableObject.connectCount > listCount - 1 ){

					variableObject.connectCount = listCount - 1;
				}

				if( setMainNeighbors || setPagerNeighbors ) neighborsSetDisabled();
			}

			animationMove( variableObject );

			if ( pagerContainer.length ) {
				pagerListContainer.removeClass( settings.selectedClassName );
				pagerListContainer.eq( variableObject.connectCount ).addClass( settings.selectedClassName );
			}

			if( settings.debug ) debug( {}, "ネイバーズボタンスライド処理" );
		}



		// ネイバーズボタン　無効用class処理
		function neighborsSetDisabled(){

			if( main.connectCount <= 0 ){

				if ( setMainNeighbors ) {

					mainPrevElement.addClass( settings.disabledClassName );
					mainNextElement.removeClass( settings.disabledClassName );
				}

				if ( setPagerNeighbors ) {

					pagerPrevElement.addClass( settings.disabledClassName );
					pagerNextElement.removeClass( settings.disabledClassName );
				}

			} else if ( main.connectCount >= listCount - 1 ){

				if ( setMainNeighbors ) {

					mainPrevElement.removeClass( settings.disabledClassName );
					mainNextElement.addClass( settings.disabledClassName );
				}

				if ( setPagerNeighbors ) {

					pagerPrevElement.removeClass( settings.disabledClassName );
					pagerNextElement.addClass( settings.disabledClassName );
				}

			} else {

				if ( setMainNeighbors ) {

					mainPrevElement.removeClass( settings.disabledClassName );
					mainNextElement.removeClass( settings.disabledClassName );
				}

				if ( setPagerNeighbors ) {

					pagerPrevElement.removeClass( settings.disabledClassName );
					pagerNextElement.removeClass( settings.disabledClassName );
				}
			}
		}





		/*
		 * アニメーションスライド処理
		 -----------------------------------------------------*/
		 function animationMove( variableObject ){

			// 横座標　式
			var abscissa = variableObject.leftIndent + -variableObject.listWidth * variableObject.connectCount;
			//main.abscissa = abscissa;
			if ( css3AnimationSupport ) {	// css3Animationが使用できる場合

				variableObject.transform = true;	// アニメーションの多重処理防止用にフラグを立てる

				var css = {};

				var duration;

				if ( variableObject.name == "main" ) {

					duration = settings.slideSpeed;

				} else {	// 無段階スライドの場合はスピード分加算する

					duration = settings.slideSpeed + Math.abs( variableObject.moveSpeed / 2 );
					variableObject.moveSpeed = 0;	// 数値が残ると外部からの操作も速度が残るので初期化
				}

				css[ css3Animation.transition ] = css3Animation.transform +' '+ duration +'ms '+ settings.transitionEasing;
				css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';

				variableObject.element.css( css );

			} else {								// 古いブラウザ等、非対応の場合

				variableObject.element.stop().animate( { left: abscissa }, { duration: settings.slideSpeed, easing: settings.jqueryEasing } );
			}
		}





		/*
		 * 自動スライドタイマー　settings.timerが1以上の場合の処理
		 -----------------------------------------------------*/
		 function autoSlideTimer() {

		 	if( !runningTimer ) {

				runningTimer = true;	// タイマーの多重処理防止用にフラグを立てる

				elements.everyTime( 100, 'timer', function() {

					time ++;

					if( time / 10 >= settings.timer ) {

						mainNeighborsSwitch( main, 1 );
						/*
						if ( settings.pagerSlide ) {

							pagerNeighborsSwitch( pager, 1 );
						}*/
					}

					if( settings.debug ) debug( {}, "タイマー" );
				});
			}
		}

		if( settings.timer ) autoSlideTimer();





		/*
		// 選択状態を解除する
		function deSelect() {

			if (window.getSelection) {

				var selection = window.getSelection();
				selection.collapse(document.body, 0);

			} else {	// IE

				var selection = document.selection.createRange();
				selection.setEndPoint("EndToStart", selection);
				selection.select();
			}
		}
		*/





		/*
		 * デバッグ
		 -----------------------------------------------------*/
		// ※IE8以下はobjectプロパティがundefinedの場合中断されるので注意　IE8以下ではデバッグしない方が良い

		// settings.debugがtrueの場合はデバッグ用エレメントを生成
		if( settings.debug ) {

			$( elements ).append('<div class="debug">待機</div>');
			var debugElement = elements.children("div.debug");
		}

		// デバッグ出力処理
		function debug( object, str ) {

			if ( settings.pagerSlide ) {

				// ※IE8以下中断注意
				var pagerStr =

				"moveSpeed ="+ pager.moveSpeed +"<br>"+
				"pager.connectCount = "+ pager.connectCount +"<br>"+
				"<br>"+
				"<dl>"+
				"<dt>pagerMarginWidth = </dt><dd>"+ pagerMarginWidth +"</dd>"+
				"<dt>pagerPaddingWidth = </dt><dd>"+ pagerPaddingWidth +"</dd>"+
				"<dt>pagerBorderWidth = </dt><dd>"+ pagerBorderWidth +"</dd>"+
				"<dt>pagerOuterWidth = </dt><dd>"+ pagerOuterWidth +"</dd>"+
				"</dl>"+
				"<br>"+
				"pagerListContainer = "+ parseInt( pagerListContainer.css('width') ) +" + "+ pagerOuterWidth +" ( "+ pager.listWidth +" )<br>"
				;
			}

			if ( !$.isEmptyObject( object ) ) {

				var objectStr =

				"touched = "+ object.touched +"<br>"+
				"X移動量 = "+ object.distanceX +" / startX = "+ object.startX +"<br>"+
				"Y移動量 = "+ object.distanceY +" / startY = "+ object.startY +"<br>"+
				"xFlag = "+ xFlag +" / yFlag = "+ yFlag +"<br>"
				;
			}

			debugElement.html(

				//"test = "+ pager.flickX +" "+ object.xBegin +" "+ object.x +"<br>"+
				//pager.flickX +" / "+ pager.listWidth +"<br>"+
				"strUserAgent = "+ strUserAgent +"<br>"+
				"<br>"+
				"runningTimer = "+ runningTimer +"<br>"+
				"time = "+ time +"<br>"+
				"main.connectCount = "+ main.connectCount +"<br>"+
				"<br>"+
				"listCount = "+ listCount +"<br>"+
				"totalWidth = "+ ( main.listWidth * listCount ) +"<br>"+
				"listInner = "+ ( main.listWidth - mainMarginWidth - mainPaddingWidth ) +"<br>"+
				"main.leftIndent = "+ main.leftIndent +"<br>"+
				//"<br>"+
				//"UL = "+ ( ( main.listWidth - mainMarginWidth - mainPaddingWidth ) * main.connectCount ) +" - "+ main.leftIndent +" = "+ parseInt( mainContainer.css('left') ) +"<br>"+
				"<br>"+
				"mainElement = "+ parseInt( mainElement.css('width') ) +"<br>"+
				"mainContainer = "+ parseInt( mainContainer.css('width') ) +"<br>"+
				"<br>"+
				"<dl>"+
				"<dt>mainMarginWidth = </dt><dd>"+ mainMarginWidth +"</dd>"+
				"<dt>mainPaddingWidth = </dt><dd>"+ mainPaddingWidth +"</dd>"+
				"<dt>mainBorderWidth = </dt><dd>"+ mainBorderWidth +"</dd>"+
				"<dt>mainOuterWidth = </dt><dd>"+ mainOuterWidth +"</dd>"+
				"</dl>"+
				"<br>"+
				"mainListContainer = "+ parseInt( mainListContainer.css('width') ) +" + "+ mainOuterWidth +" ( "+ main.listWidth +" )<br>"+
				"<br>"+
				pagerStr +
				"<br>"+
				"css3AnimationSupport = "+ css3AnimationSupport +"<br>"+
				"opacity = "+ settings.opacity +"<br>"+
				"<br>"+

				objectStr +
				"<br>"+

				"ステータス = "+ str +"<br>"
				);
}

		// method chainが途切れないように、最後にreturn thisを書く
		return this;
	};

})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ../jquery.flickslide/jquery.flickslide.js
 ** module id = 3
 ** module chunks = 0
 **/